export const GET_BRANCHES = 'GET_BRANCHES';
export const GET_BRANCHES_SUCCESS = 'GET_BRANCHES_SUCCESS';
export const GET_HOME_BRANCHES_SUCCESS = 'GET_HOME_BRANCHES_SUCCESS';
export const GET_BRANCHES_FAIL = 'GET_BRANCHES_FAIL';

export const getBranches = (payload = {}) => ({
  type: GET_BRANCHES,
  payload,
});
